// @flow
import sortBy from 'lodash/fp/sortBy';

import { photoSorter } from '@screens/Details/Facility/redux/utils';

import type { Photo, Company, Worker } from '../types';

type Relationships = {
  photos: Array<Photo>,
  workers: Array<Worker>
};

export const connectIncludedData = (company: Company, included: Array<Photo | Worker>): Company => {
  const relationships: Relationships = included.reduce(
    (acc: Relationships, resource: any) => {
      const {
        type,
        attributes: { is_active }
      } = resource;

      if (type === 'photo') acc.photos.push(resource);
      else if (type === 'worker' && is_active) acc.workers.push(resource);

      return acc;
    },
    { photos: [], workers: [] }
  );

  // Sorting photos by file names extracted from url
  relationships.photos = sortBy(photoSorter, relationships.photos);

  return {
    ...company,
    relationships: {
      ...company.relationships,
      photos: { data: relationships.photos },
      workers: { data: relationships.workers }
    }
  };
};
